import axios from "axios";

import myConfig from "../../configs/config";
import { sumLandPlotAreaHa as sumPlotAreaHa } from "../../utils/mapMeasurements";

export { sumPlotAreaHa as sumLandPlotAreaHa };

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

export function normalizeListResponse(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export async function fetchGroupFarms(contextFarmId) {
  const response = await axios.get(`${myConfig.API_URL}/farm/group/`, {
    params: { farm_id: contextFarmId },
    headers: authHeaders(),
  });
  return normalizeListResponse(response.data);
}

export async function fetchGroupLandPlots(contextFarmId) {
  const response = await axios.get(`${myConfig.API_URL}/landplot/`, {
    params: { farm_id: contextFarmId },
    headers: authHeaders(),
  });
  return normalizeListResponse(response.data);
}

export async function createGroupFarm(
  contextFarmId,
  name,
  boundaryWkt,
  options = {}
) {
  const payload = {
    context_farm_id: parseInt(contextFarmId, 10),
    nome_da_fazenda: name.trim(),
  };
  if (boundaryWkt) {
    payload.boundary_wkt = boundaryWkt;
  }
  if (options.alwaysCreate) {
    payload.always_create = true;
  }
  const response = await axios.post(`${myConfig.API_URL}/farm/quick/`, payload, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function updateGroupFarm(contextFarmId, farmId, name) {
  const response = await axios.patch(
    `${myConfig.API_URL}/farm/group-member/`,
    {
      context_farm_id: parseInt(contextFarmId, 10),
      farm_id: parseInt(farmId, 10),
      nome_da_fazenda: name.trim(),
    },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function updateGroupFarmBoundary(contextFarmId, farmId, boundaryWkt) {
  const response = await axios.patch(
    `${myConfig.API_URL}/farm/group-member/`,
    {
      context_farm_id: parseInt(contextFarmId, 10),
      farm_id: parseInt(farmId, 10),
      boundary_wkt: boundaryWkt,
    },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function deleteGroupFarm(contextFarmId, farmId) {
  await axios.delete(`${myConfig.API_URL}/farm/group-member/`, {
    params: {
      context_farm_id: parseInt(contextFarmId, 10),
      farm_id: parseInt(farmId, 10),
    },
    headers: authHeaders(),
  });
}

export function landPlotsForFarms(landPlots, serviceFarmIds) {
  if (!Array.isArray(serviceFarmIds) || serviceFarmIds.length === 0) return [];
  const idSet = new Set(serviceFarmIds.map(String));
  return landPlots
    .filter((plot) => idSet.has(String(plot.farm)))
    .sort((a, b) => {
      const farmCompare = (a.farm_name || "").localeCompare(
        b.farm_name || "",
        "pt-BR"
      );
      if (farmCompare !== 0) return farmCompare;
      return (a.name || "").localeCompare(b.name || "", "pt-BR");
    });
}

/** @deprecated use landPlotsForFarms */
export function landPlotsForFarm(landPlots, serviceFarmId) {
  if (!serviceFarmId) return [];
  return landPlotsForFarms(landPlots, [serviceFarmId]);
}

export function landPlotAddUrl(contextFarmId, serviceFarmId) {
  const base = `/${contextFarmId}/landplots/add`;
  if (!serviceFarmId) return base;
  return `${base}?target_farm_id=${serviceFarmId}`;
}
